import DarkLogo from 'assets/imgs/logos/logo.png';
import { ConfigContext } from 'contexts/ConfigContext';
import React, { useContext } from 'react'
import styled from 'styled-components';

const FooterWrapper = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    height: 2.25rem;
    width: 100%;
    z-index: 100;
    background-color: ${props => props.theme.LayoutBodyBackground};
    border-top: ${props => props.theme.DefaultBorder};
    padding: 0 1.75rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .footer-html-content {
        font-size: 0.8rem;
        line-height: 1.25rem;
    }

    p {
        font-size: 0.7rem;
        text-transform: uppercase;
        margin: 0;
        padding: 0;
        line-height: 1em;
        vertical-align: baseline;
        text-align: right;

        img {
            height: .8rem;
            vertical-align: middle;
            padding-left: .15rem;
            padding-bottom: .2rem;
            box-sizing: content-box;
        }
    }
`

const NwFooter = () => {
    const { clientConfig } = useContext(ConfigContext)
    const { footer } = clientConfig
    return (
        <FooterWrapper>
            {footer && footer.htmlContent
                ?
                <div className="footer-html-content" dangerouslySetInnerHTML={{ __html: footer.htmlContent }} />
                :
                <p></p>
            }
            <p><a href="https://www.netwalk.eu" target="_blank">powered by <img className="nw-logo" src={DarkLogo} alt="NETWALK4" /></a></p>
        </FooterWrapper>
    )
}

export default NwFooter

